import React, { useEffect, useState } from "react";
import Recorder from "../../QuestionPage/recorder";
import ImageBox from "../../QuestionPage/ImageBox";
import ExamPanel from "../ExamPanel";

export default function DescribeImageMockPage({
  question,
  onInputChange,
  questionNumber,
  ...props
}) {
  const [text, setText] = useState("");
  const [imageLink, setImageLink] = useState("");

  useEffect(() => {
    const fetchImageUrl = async () => {
      try {
        const res = await fetch(question.media_link);
        const data = await res.json();
        setImageLink(data.url);
      } catch (err) {
        console.error("Failed to fetch image URL:", err);
      }
    };

    if (question?.media_link) fetchImageUrl();
  }, [question]);

  const handleTextChange = (newText) => {
    if (newText !== text) {
      setText(newText);
      onInputChange(newText);
    }
  };

  return (
    <ExamPanel
      eyebrow="Speaking"
      title="Describe Image"
      questionLabel={`Question ${questionNumber} of 36`}
      instructions="Look at the image below. In 25 seconds, speak into the microphone and describe in detail what it shows. You will have 40 seconds to respond."
    >
      <div className="grid gap-6 xl:grid-cols-[minmax(420px,1fr),420px] xl:items-start">
        <div className="rounded-md border border-slate-200 bg-slate-50 p-4">
          <ImageBox link={imageLink} />
        </div>
        <div className="rounded-md border border-slate-200 bg-white p-4">
          <Recorder
            text={text}
            setText={handleTextChange}
            {...props}
            duration={40}
            startAt={25}
            className="min-h-56 w-full rounded-md border border-slate-200 bg-slate-50"
          />
        </div>
      </div>
    </ExamPanel>
  );
}
